<script setup lang="ts">
import cliLogo from '~/assets/img/cli-logo.svg'
</script>

<template>
  <NavBar />
  <img width="343.45px" height="96px" class="mt-5" :src="cliLogo" alt="CLI Logo" />
  <main class="container-md g-2" style="min-height: calc(100vh - 50px)">
    <slot />
  </main>
  <PageFooter />
</template>
